<template>
  <div id="shop_details">
    <div class="bottombox">
      <Header ref="header" />
      
    </div>
    <!-- bottombox end -->
    <div class="hotgkt">
      <div class="BreadcrumbNavigation">
        您当前所在位置：<a href="/shop_list">积分商城</a> &gt;&gt;
        <span>美国Melais儿童保温杯带吸管便携幼儿园水杯</span>
      </div>
    </div>
    <!-- hotgkt end -->
    <div class="box_top clearfix">
      <div class="Existing_integral" v-if="loginIF">
        当前可用积分：{{ yyjf }}积分
      </div>
      <dl class="clearfix">
        <dt><img :src="CoverImg" v-if="CoverImg" /></dt>
        <dd>
          <h2>{{ title }}</h2>
          <h3>兑换积分：{{ dhjf }}积分</h3>
          <p>价值：￥{{ jiazhi }}</p>
          <p>库存：{{ kucun }}</p>
          <p>
            数量：<el-input-number
              size="mini"
              :min="1"
              :max="kucun"
              v-model="num"
              @change="change"
            ></el-input-number>
          </p>
          <p>小计：{{ xyjf }}积分</p>
          <button @click="exchange" :disabled="dis" :class="{ btn: dis }">
            立即兑换
          </button>
        </dd>
      </dl>
    </div>
    <!-- box_top end -->
    <div id="position" class="pos_f" v-if="position">
      <div class="position_left clearfix">
        <h2>
          {{ title }}<span>/{{ dhjf }}积分</span>
        </h2>
        <button @click="exchange" :disabled="dis" :class="{ btn: dis }">
          立即兑换
        </button>
      </div>
    </div>
    <div class="main" id="main_content">
      <div class="title">商品介绍</div>
      <div class="main_center clearfix">
        <div v-html="Content" class=""></div>
      </div>
    </div>
    <!-- main end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部

export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header,
    
  },
  metaInfo() {
    return {
      title: "积分商城-启德考培在线_出国考试在线培训_考培网校",
      meta: [
        {
          name: "keywords",
          content:
            "启德考培在线积分商城,启德考培在线课程,雅思在线课程,托福在线课程"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      yyjf: "",
      CoverImg: "",
      title: "",
      dhjf: "",
      jiazhi: "",
      kucun: 0,
      num: 1,
      xyjf: "",
      Content: "",
      dis: true,
      scroll: "",
      position: false,
      ljyycg: false,
      sw: 1,
      loginIF: false
    };
  },
  methods: {
    exchange() {
      this.$router.push({
        path: "/shop_order",
        query: {
          shopId: this.$route.query.shopId,
          num: this.num
        }
      });
    },
    change() {
      this.xyjf = this.num * this.dhjf;
      // 判断积分是否充足
      if (this.yyjf < this.xyjf) {
        this.dis = true;
      } else {
        this.dis = false;
      }
    },
    closeTan() {
      this.ljyycg = false;
    },
    menu() {
      this.scroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.getElementById("app").offsetTop + 450;
      if (this.scroll > offsetTop) {
        this.position = true;
      } else {
        this.position = false;
      }
    },
    reloads() {
      let that = this;
      // 个人信息
      this.$http
        .get("https://schoolapi.eiceducation.com.cn/api/UserInfo", {
          headers: {
            token: this.$cookies.get("token")
          }
        })
        .then(function(result) {
          // // console.log(result)
          that.loginIF = true;
          that.yyjf = result.data.results.Integral;
          // 判断积分是否充足
          if (that.yyjf < that.xyjf) {
            // // console.log("积分不足")
            that.dis = true;
          } else {
            // // console.log("积分充足")
            that.dis = false;
          }
           if (that.$cookies.get("token")) {
            that.$store.commit("setUserInfo", result.data.results);
          } else {
            that.$store.commit("setUserInfo", { Type: 1 });
          }
        })
        .catch(function(error) {
          // console.log(error);
          that.$message.error(error);
        });
    }
  },
  created: function() {
    let that = this;
    // 商品详情接口
    this.$http
      .get(
        "https://schoolapi.eiceducation.com.cn/api/Goods/" +
          this.$route.query.shopId
      )
      .then(function(result) {
        // // console.log(result)
        that.CoverImg = result.data.results.CoverImg;
        that.title = result.data.results.Title;
        that.dhjf = result.data.results.ConversionPrice;
        that.jiazhi = result.data.results.Money;
        that.kucun = result.data.results.Count;
        that.xyjf = result.data.results.ConversionPrice * that.num;
        that.Content = result.data.results.Content;
      })
      .catch(function(error) {
        // console.log(error);
      });
  },
  mounted: function() {
    //自动触发写入的函数
    let that = this;
    window.addEventListener("scroll", this.menu);
    that.tokenkey = that.$cookies.get("token");
    if (!that.tokenkey) {
      that.$message.warning("请您登录后进行兑换！");
      return;
    }
    that.reloads();
  }
};
</script>

<style scoped id="shop_details">
#shop_details {
  background: #fafafa;
  padding-bottom: 28px;
}

.bottombox {
  box-shadow: 0px 3px 5px 0px rgba(233, 233, 233, 0.5);
  position: relative;
  z-index: 9;
}

.hotgkt {
  background: #fff;
}

.BreadcrumbNavigation {
  width: 1180px;
  text-align: left;
  font-size: 16px;
  color: #333;
  line-height: 56px;
  margin: 0 auto;
}

.BreadcrumbNavigation a {
  font-size: 16px;
  color: #333;
}

.BreadcrumbNavigation span {
  font-size: 16px;
  color: #ff4253;
}

.box_top {
  width: 100%;
  background: #ffffff;
  margin-bottom: 36px;
}

.Existing_integral {
  width: 1180px;
  font-size: 18px;
  color: #333;
  line-height: 28px;
  text-align: left;
  margin: 0 auto;
  margin-bottom: 19px;
  font-family: "思源黑体 CN Regular";
}

.box_top dl {
  width: 1180px;
  margin: 0 auto;
  padding-bottom: 20px;
}

.box_top dl dt {
  width: 160px;
  height: 160px;
  float: left;
  margin-right: 16px;
  overflow: hidden;
  background: url(../../assets/selfStudy/img.png) center no-repeat;
  background-size: cover;
}
.box_top dl dt img {
  width: 100%;
}

.box_top dl dd {
  width: 870px;
  float: left;
  text-align: left;
}

.box_top dl dd h2 {
  font-size: 16px;
  color: #333333;
  line-height: 26px;
  margin-bottom: 12px;
  font-weight: normal;
}

.box_top dl dd h3 {
  display: inline-block;
  height: 32px;
  background: #f5f6f6;
  border-radius: 28px;
  font-size: 16px;
  color: #f84949;
  text-align: center;
  line-height: 32px;
  margin-bottom: 10px;
  padding: 0 20px;
}

.box_top dl dd p {
  font-size: 12px;
  color: #333333;
  line-height: 12px;
  padding: 2px 0;
}

.box_top dl dd button {
  width: 116px;
  height: 32px;
  background: linear-gradient(90deg, #ff7c71 0%, #ff3250 100%);
  border-radius: 30px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  border: none;
  margin-top: 12px;
}

.box_top dl dd .btn {
  background: linear-gradient(180deg, #f1f0f0 0%, #e1e1e1 100%);
  color: #666666;
  cursor: not-allowed;
}

#position {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(153, 153, 153, 0.5);
}

#position .position_left {
  width: 1100px;
  margin: 0 auto;
  padding: 10px 0;
  padding-right: 80px;
}

#position .position_left h2 {
  font-size: 16px;
  color: #333333;
  line-height: 32px;
  float: left;
  font-weight: normal;
}

#position .position_left h2 span {
  color: #ff3250;
  font-size: 16px;
}

#position .position_left button {
  width: 116px;
  height: 32px;
  background: linear-gradient(90deg, #ff7c71 0%, #ff3250 100%);
  border-radius: 30px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  border: none;
  float: right;
}

#position .position_left .btn {
  background: linear-gradient(180deg, #f1f0f0 0%, #e1e1e1 100%);
  color: #666666;
  cursor: not-allowed;
}

.main {
  width: 1180px;
  background: #ffffff;
  border-radius: 12px;
  margin: 0 auto;
}

.main .title {
  width: 1020px;
  height: 91px;
  box-sizing: border-box;
  border-bottom: 1px #d5d5d5 solid;
  font-size: 20px;
  color: #333333;
  padding-bottom: 27px;
  padding-top: 43px;
  text-align: left;
  font-weight: 500;
  margin: 0 auto;
}

.main .main_center {
  padding: 30px 80px;
}

.main .main_center p {
  text-align: left;
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/page2/shopping/shop_details.vue